import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from '../shared/services/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  authService = inject(AuthService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // add auth header with jwt if user is logged in and request is to the api url
    const currentUser = this.authService.currentUser;
    const isLoggedIn = currentUser; // && currentUser.userGuid;
    const isApiUrl = request.url.startsWith(environment.apiBaseUrl);
    if (isLoggedIn && isApiUrl) {
      return from(this.authService.getAccessToken()).pipe(
        switchMap(token => {
          // getAccessToken() decide qué transporte aplica (header vs cookie); aquí solo añadimos
          // el header cuando devolvió un token no vacío.
          if (token) {
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`,
              },
            });
          }
          return next.handle(request);
        }),
      );
    }

    return next.handle(request);
  }
}
